import { POPUP, LIST_TEMPLATE_NAMES } from '../constants'

const initState = {
	request: null,
	response: null,
	error: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case LIST_TEMPLATE_NAMES.LOAD:
			return {
				...state,
				request: action.request,
				response: null,
				error: null,
			}
		case LIST_TEMPLATE_NAMES.SUCCESS:
			return {
				...state,
				response: action.response,
			}
		case LIST_TEMPLATE_NAMES.ERROR:
			return {
				...state,
				error: action.error,
			}
		case POPUP.CLOSE:
			return {
				...state,
				error: null,
			}
		default:
			return state
	}
}
